import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {view} from '@sail/ui';
import {FormattedMessage, defineMessages} from 'react-intl';
import {SafeAnchor} from '@stripe-internal/safe-links';

const messages = defineMessages({
  reasonNotice: {
    id: 'risk.url_intervention.reason_notice',
    description: 'Reason notice shown when there are problems with the website',
    defaultMessage:
      "Business website information is required by Stripe's terms of service. Stripe pauses payments and payouts if we cannot verify your information.",
  },
  problemsNotice: {
    id: 'risk.url_intervention.problems_notice',
    description: 'Notice shown when there are problems with the website',
    defaultMessage:
      'Please fix the following {count, plural, one {problem} other {# problems}} with your website',
  },
});

export type ValueProps = {
  intervention_reasons?: string[];
  website_url?: string;
};

export const UrlIntervention = (props: InlineDatumReactComponentProps) => {
  const {datum} = props;
  const value = datum.value as ValueProps;

  const {intervention_reasons: interventionReasons} = value;

  if (!interventionReasons || interventionReasons.length === 0) {
    return <view.div>None</view.div>;
  }

  return (
    <view.div>
      <FormattedMessage {...messages.reasonNotice} />
      <br />
      <br />
      <FormattedMessage
        {...messages.problemsNotice}
        values={{
          count: interventionReasons.length,
        }}
      />
      {value.website_url ? (
        <view.div>
          (
          <SafeAnchor
            href={value.website_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value.website_url}
          </SafeAnchor>
          ):
        </view.div>
      ) : (
        <div>:</div>
      )}
      {interventionReasons.length === 1 ? (
        <view.div style={{marginTop: '.5em'}}>
          {interventionReasons[0]}
        </view.div>
      ) : (
        <view.ol style={{marginTop: '.5em', paddingLeft: '1em'}}>
          {interventionReasons.map((reason) => (
            <view.li key={reason} style={{marginBottom: '.5em'}}>
              {reason}
            </view.li>
          ))}
        </view.ol>
      )}
    </view.div>
  );
};
